import React from 'react';
import { Paper, Button } from '@mui/material';
import { AppTitle } from '../components/app/appTitle';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../components/preAuthentification/msalConfig';

const styles = {
  mainContainer: {
    background:
      'linear-gradient(45deg, rgba(21,33,69,1) 0%, rgba(62,160,212,1) 74%, rgba(0,212,255,1) 100%)',
    width: '100vw',
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paperLogin: {
    display: 'flex',
    flexDirection: 'column',
    p: 10,
    textAlign: 'center',
  },
};

export function PageLogin(): JSX.Element {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect(loginRequest);
  };

  return (
    <main style={styles.mainContainer}>
      <Paper elevation={10} sx={styles.paperLogin}>
        <AppTitle />
        <Button
          variant="contained"
          fullWidth
          onClick={handleLogin}
          sx={{ height: '4rem', mt: 2 }}
        >
          Sign in with Microsoft
        </Button>
      </Paper>
    </main>
  );
}
